import { useEffect, useState } from 'react';

const brasiliaMonth = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Sao_Paulo',
  month: 'numeric',
});

export function isOctoberInBrasilia(date = new Date()): boolean {
  return brasiliaMonth.format(date) === '10';
}

export function useOctoberRosa(): boolean {
  // Initial value is false on the server AND during hydration of SSG pages, so the
  // first client render matches the static HTML; the effect below applies the date.
  const [active, setActive] = useState(() =>
    typeof window === 'undefined' || (window as any).__NATHOF_HYDRATING__ ? false : isOctoberInBrasilia(),
  );

  useEffect(() => {
    // Hydration of this tree is committed; later mounts use the real date at once.
    (window as any).__NATHOF_HYDRATING__ = false;
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      const now = new Date();
      setActive(isOctoberInBrasilia(now));
      // Brasília midnight is 03:00 UTC; refresh even if the page stays open.
      const nextMidnight = new Date(now);
      nextMidnight.setUTCHours(3, 0, 0, 0);
      if (nextMidnight.getTime() <= now.getTime()) {
        nextMidnight.setUTCDate(nextMidnight.getUTCDate() + 1);
      }
      timer = setTimeout(refresh, nextMidnight.getTime() - now.getTime());
    };
    refresh();
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, []);

  return active;
}